import { Box, Text, Tooltip } from '@wix/design-system';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback } from 'react';
import { ThemeAwareIcon } from '../../../../utils/theme-aware-icon';
export const CollapseListSectionItem = /*#__PURE__*/React.memo(_ref => {
  let {
    title,
    dataHook,
    prefix,
    subtitle,
    suffix,
    showTooltip = true,
    tooltipText,
    disabled,
    backgroundColor = 'D70',
    titleWeight = 'normal',
    titleSkin = 'standard',
    tooltipSize = 'medium'
  } = _ref;
  const renderTitle = useCallback(() => {
    if (typeof title === 'string') {
      return /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        skin: titleSkin,
        weight: titleWeight
      }, title);
    }
    return title;
  }, [title, titleSkin, titleWeight]);
  const renderTooltip = useCallback(() => {
    if (showTooltip) {
      return /*#__PURE__*/React.createElement(Tooltip, {
        content: tooltipText,
        disabled: disabled,
        size: tooltipSize
      }, /*#__PURE__*/React.createElement(Box, {
        color: disabled ? 'D40' : undefined,
        height: "18px",
        verticalAlign: "middle",
        width: "18px"
      }, disabled ? /*#__PURE__*/React.createElement(InfoCircleSmall, null) : /*#__PURE__*/React.createElement(ThemeAwareIcon, {
        height: "18px",
        width: "18px"
      }, /*#__PURE__*/React.createElement(InfoCircleSmall, null))));
    }
    return null;
  }, [disabled, showTooltip, tooltipSize, tooltipText]);
  const renderHeader = useCallback(() => {
    return /*#__PURE__*/React.createElement(Box, {
      align: "space-between",
      backgroundColor: backgroundColor,
      dataHook: dataHook,
      direction: "horizontal",
      padding: "8px 16px",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP1",
      verticalAlign: "middle"
    }, prefix, /*#__PURE__*/React.createElement(Box, {
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP1",
      style: {
        alignItems: 'center'
      }
    }, renderTitle(), renderTooltip()), subtitle)), /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP2",
      verticalAlign: "middle"
    }, suffix));
  }, [backgroundColor, dataHook, prefix, renderTitle, renderTooltip, subtitle, suffix]);
  return renderHeader();
});
//# sourceMappingURL=collapse-list-section-item.js.map